module.exports = __webpack_public_path__ + "static/media/f_eyeshape_hooded_amber.dc9d8d0b.png";